module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "dashboard",
    attrs: {
      "element-loading-text": "Connecting..."
    }
  }, [_c('claim', {
    attrs: {
      "scanning": _vm.scanning
    },
    on: {
      "update:scanning": function($event) {
        _vm.scanning = $event
      }
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "float-button",
    on: {
      "click": function($event) {
        _vm.scanning = true;
      }
    }
  }, [_c('float-button')], 1), _vm._v(" "), (_vm.noProducts) ? _c('div', {
    staticClass: "sorry"
  }, [(_vm.unconfirmeds.length === 0) ? _c('div', [_vm._v("Please claim your 1st asset.")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "products-wrapper"
  }, [_c('div', {
    staticClass: "item-wrapper plus-button"
  }, [_c('dashboard-plus-button', {
    nativeOn: {
      "click": function($event) {
        return _vm.claim($event)
      }
    }
  })], 1), _vm._v(" "), _vm._l((_vm.unconfirmeds), function(transaction) {
    return _c('div', {
      key: transaction.meta.hash.data,
      staticClass: "item-wrapper"
    }, [_c('dashboard-item-loading')], 1)
  }), _vm._v(" "), _vm._l((_vm.products), function(product, index) {
    return _c('div', {
      key: index,
      staticClass: "item-wrapper"
    }, [_c('dashboard-item', {
      attrs: {
        "product": product,
        "imgUrl": _vm.getImgUrl(product)
      },
      on: {
        "onItemClick": function($event) {
          return _vm.openProduct(product.address)
        }
      }
    })], 1)
  })], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2bf2fbfe","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard.vue
// module id = 1170
// module chunks = 2